import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import styles from './LocalAnswers.module.scss';
import { ReactComponent as AnsveredSvg } from '../../../../../../assets/svg/checkMark.svg';

import { GET_LOCAL_QUESTIONS_DATA } from '../../../../../../api';
import { useQuery } from '@apollo/client';
import { filterLocalCategory } from 'utils/calculatorUtils';
import ResultFilesModal from '../../../CalcResultFilesModal/ResultFilesModal';

const LocalAnswers = ({ params }) => {
  const { resultFiles, answersData, type, title } = params;

  const { data: questions } = useQuery(GET_LOCAL_QUESTIONS_DATA);

  const [questionsData, setQuestionsData] = useState([]);
  const [resultsList, setResultsList] = useState({});
  const [resultsFilesList, setResultsFilesList] = useState([]);
  const [resultsFilesCodes, setResultsFilesCodes] = useState([]);

  useEffect(() => {
    if (!questions?.questions) return;
    setQuestionsData(filterLocalCategory(questions.questions, type));
  }, [questions]);

  useEffect(() => {
    const scopeMap = Object.values(questionsData).reduce(
      (acc, item) => ({
        ...acc,
        [item.code]: {
          question: item.title,
          subquestion: null,
          code: item.code,
          title: title,
          files: [],
        },
      }),
      {}
    );

    resultFiles.forEach((file) => {
      if (scopeMap[file.questionCode]) {
        scopeMap[file.questionCode].files.push(file);
      }
    });

    const resultObject = Object.values(scopeMap).filter((item) => item.files.length > 0);
    setResultsFilesList([...resultObject]);
    setResultsFilesCodes([...resultObject.map((q) => q.code)]);
  }, [resultsList]);

  useEffect(() => {
    if (!questionsData || !answersData.localAnswers) return;
    const res = Object.keys(questionsData).map((key) => ({
      ...questionsData[key],
      answer: answersData.localAnswers[key],
    }));
    setResultsList([...res]);
  }, [questionsData, answersData]);

  return (
    <div className={styles.localMainFrame}>
      {resultsList && resultsList.length > 0 && (
        <div>
          {resultsList.map((res) => (
            <div key={res.code}>
              <div className={styles.container}>
                <div className={styles.localAnswerBlock}>
                  <div className={styles.questionTitle}>
                    <AnsveredSvg
                      className={clsx(
                        styles.qbuttonsvg,
                        { [styles.required]: res.answer === undefined },
                        { [styles.answered]: res.answer !== undefined }
                      )}
                    />
                    <h4>{res.title}</h4>
                  </div>
                  {res.body && <div>• {res.body.replace(/^-\s?/i, '')}</div>}
                  <div>
                    <span className={styles.labelAnswer}>Answer: </span>
                    {res.answer === undefined && 'No answer available'}
                    {res.answer !== undefined && res.type === 'bool' && (res.answer ? 'YES' : 'NO')}
                    {res.answer !== undefined && res.type !== 'bool' && res.answer}
                  </div>
                </div>
                {resultsFilesCodes.includes(res.code) && (
                  <div className={styles.buttonBlock}>
                    <ResultFilesModal
                      params={{
                        resultsFilesList,
                        resultsFilesCodes,
                        code: res.code,
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
      {!resultsList && resultsList.length === 0 && <div>Results are empty</div>}
    </div>
  );
};

export default LocalAnswers;
